const useSocialLinks = (siteSetting, color, text = true) => {
  const SocialSiteLink = ({ uri, iconClass }) => {
    return (
      <>
        {uri && (
          <a className="me-2" href={uri} style={{ color }} target="_blank" rel="noopener noreferrer">
            <i className={`bi bi-${iconClass} fs-5`}></i>
          </a>
        )}
      </>
    );
  };

  const Social = () => {
    return (
      <>
        {(siteSetting.companySocialsInstragramUri ||
          siteSetting.companySocialsLinkedInUri ||
          siteSetting.companySocialsFaceboookUri) && (
          <div className="d-flex p-10 align-items-center">
            {text && <span className="me-2">Find Us On: </span>}
            <SocialSiteLink uri={siteSetting.companySocialsInstragramUri} iconClass="instagram" />
            <SocialSiteLink uri={siteSetting.companySocialsLinkedInUri} iconClass="linkedin" />
            <SocialSiteLink uri={siteSetting.companySocialsFaceboookUri} iconClass="facebook" />
          </div>
        )}
      </>
    );
  };

  return { Social };
};

export { useSocialLinks };
